<template>
<div class="raiz">
    <div class="cabecalho">
      <div class="barra">
          <!-- <div class="retorno" @click="retornar">
            <mdi-retornar></mdi-retornar>
          </div> -->
          <div class="logo">
              <img src="@/assets/logo.png"/>
          </div>
          <!-- <div class="areapesquisa">
            <div class="pesquisa">
              <div style="width:100%">
                <input type=text class="procure" placeholder="O que você procura?" v-model="pesquisa" />
              </div>
              <div class="lupa">
                <mdi-pesquisa @click="pesquisar"></mdi-pesquisa>
              </div>
            </div>
          </div> -->
          <!-- <div class="botoes">
            <div class="carrinho" @click="cesta">
              <mdi-carrinho></mdi-carrinho>
            </div>
          </div> -->
      </div>
      <div class="fones">
        <div class="dados">Centro: (21) 99613-9311  (21) 2507-1422</div>
        <div class="dados">Polo Textil: (21) 99613-9634  (21) 2137-5232</div>

      </div>

      <div class="selecao">
        <div class="retorno" @click="retornar">
          <mdi-retornar></mdi-retornar>
        </div>
        <div class="texto">{{selecao}}</div>
      </div>
    </div>
    <div id="divartigos" class="artigos" >
            <div v-for="g in referencias" v-bind:key="g.id">
              <div class="referencia" @click="selecionou(g.id)">
                <div class="imagem">
                  <img :src="'' + g.imagem + ''"/>
                </div>
                <div class="descricao">{{ g.ordem }} - {{ g.peca }}</div>
                <div class="descricao">{{ g.descricao }}</div>
                <!-- <div class="composicao">{{ g.composicao }}</div> -->
                <div class="cor">{{ g.corassuf }}</div>
                <div v-if="g.empromocao==0" class="preco">{{ g.preco }}</div>
                <div v-if="g.empromocao==1" class="precos">
                  <div class="precocheio">de {{ g.preco }}</div>
                  <div class="precopromocao"> por {{g.precopromocao}}</div>
                </div>
              </div>
            </div>
    </div>
    <rodape></rodape>
</div>
</template>

<style lang="scss" scoped>
  @import "@/assets/scss/artigos.scss";

</style>

<script>
import mvitrine from '@/dados/mvitrine'

// import Submenuh from '../components/submenuh.vue'
import Rodape from '../components/rodape.vue'

export default {
  components:{
    // 'submenuh': Submenuh,
    'rodape': Rodape,
  },
  data: function(){

    return {
      topo: '200px',

      pesquisa: "",

      referencias: null,
      temCarrinho: false,
      selecao: "",
    }

  },
  methods:{
    retornar: function(){
      this.$router.push("vitrine");

    },
    pesquisar: function(){
      if (this.pequisa != ""){
        this.$store.commit("pesquisaLivreMudou",this.pesquisa);
      }
    },
    cesta: function(){
//      this.$router.push("cesta");
    },

    selecionou(idReferencia){
      sessionStorage.setItem("vitrine.idreferencia",idReferencia);
//      this.$router.push("artigo");

    },
    recuperarReferencias(){
      mvitrine.recuperarReferencias(this.pesquisaArea,this.pesquisaGrupo).then(()=>{
        this.referencias=mvitrine.retorno;
      })
    },
    recuperarReferenciasLivre(){
      if (this.pesquisaLivre != ""){
        this.$store.commit("pesquisaAreaMudou","");
        this.$store.commit("pesquisaGrupoMudou","");
        mvitrine.recuperarReferenciasLivre(this.pesquisaLivre).then(()=>{
        this.referencias=mvitrine.retorno;
      })
      }
    }
  },
  created(){
    this.temCarrinho = false;
    if (localStorage.getItem("vitrine.carrinho") != null && localStorage.getItem("vitrine.carrinho").toString().length > 0){
      this.temCarrinho = true;
    }
    var removeu = false;
    var cesta = localStorage.getItem("vitrine.cesta")
    console.log("cesta " + cesta);
    if (cesta != null){
        for (var i=cesta.length-1;i>=0;i--){
          console.log(cesta[i].datacompra);
          var agora = new Date();
          if (cesta[i].datacompra == undefined || new Date(cesta[i].datacompra) < agora.setDate(agora.getDate()-7)){
            cesta.splice(i,1);
            removeu = true;
          }
          console.log(cesta);
        }
        if (removeu){
              localStorage.setItem('vitrine.cesta',cesta);
        }
    }

  },
  mounted(){
    let area = sessionStorage.getItem("vitrine.area");
    let codgrupo = sessionStorage.getItem("vitrine.codgrupo");
    let grupo = sessionStorage.getItem("vitrine.grupo");
    area = (area==null?"":area);
    codgrupo = (codgrupo==null?"":codgrupo);
    this.selecao = area + ' - ' + grupo;

    mvitrine.recuperarReferencias(area,codgrupo).then(()=>{
      this.referencias = mvitrine.retorno;

    });

    let divartigos = document.getElementById('divartigos');
    divartigos.scrollTop = 0;
//    location.reload();
  }
}
</script>